const base_url = "https://assist.quadrafort.com/api";
// latest api

export { base_url };
